import React from 'react';
import './ItemList.scss';
import Item from '../Item/Item';
import 'react-image-lightbox/style.css';

export default ({ items }) => {

  return (
    <div className="item-list">
      <ul className="item-list__list">
        {items.map((item) => (
          <li
            className="item-list__list__item"
            key={item.id}          
          >
            <Item
              item={item}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}